import { createReducer, createActions } from "reduxsauce"

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  submitRenewal: null,
  submitNew: null,
  analyticsQuestionAnswered: ["FORM_NAME", "step", "value"],
  analyticsQuestionViewed: ["FORM_NAME", "step", "value"],
  analyticsIdentify: ["eventPayload"]
})

export const WizardTypes = Types
export default Creators

export const INITIAL_STATE = {
  loading: false
}

export const submitRenewal = state => state
export const submitNew = state => state

export const questionAnswered = state => state

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SUBMIT_RENEWAL]: submitRenewal,
  [Types.SUBMIT_NEW]: submitNew,
  [Types.ANALYTICS_QUESTION_ANSWERED]: questionAnswered,
  [Types.ANALYTICS_QUESTION_VIEWED]: questionAnswered,
  [Types.ANALYTICS_IDENTIFY]: questionAnswered
})



// WEBPACK FOOTER //
// ./src/redux/wizard.redux.js